module.exports = __webpack_public_path__ + "img/yiquxiao.a808616a.svg";